module.exports = __webpack_public_path__ + "a9f1cb980b926002e2200658c8e9dfaa.svg";